import Composition from 'src/lib/HOC/Composition';
import { formatModalId } from 'src/lib/Utils/helpers';
import { data } from './data';
import ModalSlideshow from './index';

const { component, compositionFunction } = Composition(ModalSlideshow)<typeof data>(
  ({ fields, rendering }) => ({
    id: formatModalId(rendering?.dataSource),
    items: fields?.items
      ?.map(({ fields }) => ({
        headline: fields?.Headline,
        subhead: fields?.Subhead,
        image: fields?.Photo,
      }))
      .filter(elm => elm.image?.value?.src),
  })
);

export { compositionFunction };
export default component;
